import calculatedCameraProps from 'helpers/cameras/calculatedCameraProps'
import convertCameraValuesToNumbers from 'helpers/convertCameraValuesToNumbers'
import initialCameraProps from 'helpers/cameras/initialCameraProps'

export default function(c) {
  const withDefaults = Object.assign({}, initialCameraProps(1), c)
  return calculatedCameraProps(convertCameraValuesToNumbers(withDefaults))
}



// WEBPACK FOOTER //
// ./src/helpers/projects/expandCamera.js